// journeyRightPanelContent.js

export const journeyRightPanelContent = {
    check_eligibility: {
    title: "Basic Details",
    subtitle: "Enter your basic details to see if you qualify for available personal loan options.",
    pill: "Takes only a few minutes",
    stats: {
      users: "10L+",
      approval: "120s",
    },
    features: [
      {
        title: "100% Secure",
        sub: "Bank-grade encryption on all data",
      },
      {
        title: "Instant Approval",
        sub: "Takes only a few minutes",
      },
      {
        title: "Trusted by users",
        sub: "Rated 4.8★ on Play Store & App Store",
      },
    ],
  },
  loan_quote: {
    title: "Loan Offer",
    subtitle: "Fast, secure & paperless verification.",
    pill: "Instant approval",
    stats: {
      users: "10L+",
      approval: "120s",
    },
    features: [
      {
        title: "100% Secure",
        sub: "Bank-grade encryption on all data",
      },
      {
        title: "Instant Approval",
        sub: "Decision in under 120 seconds",
      },
      {
        title: "Trusted by users",
        sub: "Rated 4.8★ on Play Store & App Store",
      },
    ],
  },

  ekyc_detail: {
    title: "EKYC",
    subtitle: "Complete Aadhaar-based eKYC and upload the required information for identity verification.",
    pill: "Safe & Secure Verification",
    stats: {
      users: "100%",
      approval: "2 Min",
    },
    features: [
      {
        title: "Aadhaar Verification",
        sub: "Safe & encrypted verification",
      },
      {
        title: "Quick Process",
        sub: "Complete within minutes",
      },
      {
        title: "RBI Compliant",
        sub: "Fully secure verification",
      },
    ],
  },

  personal_details: {
    title: "Personal details",
    subtitle: "Confirm your residential address and location details to continue your application.",
    pill: "Address Verification",
    stats: {
      users: "5 Min",
      approval: "Easy",
    },
    features: [
      {
        title: "Quick Verification Process",
        sub: "Confirm your residential address and location details to continue your application.",
      },
      {
        title: "Fast",
        sub: "Takes less than 5 minutes",
      },
      {
        title: " Secure Identity Check",
        sub: "Capture a live selfie to complete identity verification and enhance account security.",
      },
    ],
  },

  upload_documents: {
    title: "Upload your documents",
    subtitle: "upload any 2 document to help us process your application efficiently fast.",
    pill: "Almost There!",
    stats: {
      users: "2 Docs",
      approval: "Fast",
    },
    features: [
      {
        title: "Secure Upload",
        sub: "Encrypted document storage",
      },
      {
        title: "Instant Review",
        sub: "Documents verified quickly",
      },
      {
        title: "Paperless",
        sub: "No physical paperwork",
      },
    ],
  },

  banking_details: {
    title: "Last Step",
    subtitle: "banking verification in just a few simple steps",
    pill: "Bank Verification",
    stats: {
      users: "100%",
      approval: "Secure",
    },
    features: [
      {
        title: "Encrypted",
        sub: "Bank-grade security",
      },
      {
        title: "Quick Verification",
        sub: "Instant account validation",
      },
      {
        title: "Safe",
        sub: "No passwords stored",
      },
    ],
  },

  completed: {
    title: "Basic Details",
    subtitle: "Enter your basic details to see if you qualify for available personal loan options.",
    pill: "Takes only a few minutes",
    stats: {
      users: "10L+",
      approval: "120s",
    },
    features: [
      {
        title: "100% Secure",
        sub: "Bank-grade encryption on all data",
      },
      {
        title: "Instant Approval",
        sub: "Takes only a few minutes",
      },
      {
        title: "Trusted by users",
        sub: "Rated 4.8★ on Play Store & App Store",
      },
    ],
  }
};